import { keyBy } from 'lodash';

const stepUpStepBackChoices = keyBy(
    [
        {
            id: 1,
            text: 'That’s not me.'
        },
        {
            id: 2,
            text: 'That’s me.'
        },
        {
            id: 3,
            text: 'N/A'
        }
    ],
    'id'
);

const stepUpStepBackPrompts = keyBy(
    [
        {
            id: 1,
            prompt: 'I speak English as a second language.',
            notMeValue: 1,
            meValue: -1,
            naValue: 0,
            artChoice: 2,
            nicoChoice: 1,
            philipChoice: 1,
            tommyChoice: 1,
            myChoice: null
        },
        {
            id: 2,
            prompt: 'I have a visible or invisible disability (have physical disability, hearing impaired, learning disability, etc.) ',
            notMeValue: 1,
            meValue: -1,
            naValue: 0,
            artChoice: 1,
            nicoChoice: 2,
            philipChoice: 1,
            tommyChoice: 2,
            myChoice: null
        },
        {
            id: 3,
            prompt: 'A person who raised me attended college',
            notMeValue: -1,
            meValue: 1,
            naValue: 0,
            artChoice: 1,
            nicoChoice: 2,
            philipChoice: 1,
            tommyChoice: 2,
            myChoice: null
        },
        {
            id: 4,
            prompt: 'I was raised by a single parent',
            notMeValue: 1,
            meValue: -1,
            naValue: 0,
            artChoice: 2,
            nicoChoice: 1,
            philipChoice: 1,
            tommyChoice: 2,
            myChoice: null
        },
        {
            id: 5,
            prompt: 'I was raised in a non-Christian household (Islam, Buddhism, etc.)',
            notMeValue: 1,
            meValue: -1,
            naValue: 0,
            artChoice: 2,
            nicoChoice: 1,
            philipChoice: 2,
            tommyChoice: 2,
            myChoice: null
        },
        {
            id: 6,
            prompt: 'I plan to attend (or am currently attending) college.',
            notMeValue: -1,
            meValue: 1,
            naValue: 0,
            artChoice: 1,
            nicoChoice: 2,
            philipChoice: 2,
            tommyChoice: 2,
            myChoice: null
        },
        {
            id: 7,
            prompt: 'I am or have been considered overweight or fat',
            notMeValue: 1,
            meValue: -1,
            naValue: 0,
            artChoice: 1,
            nicoChoice: 2,
            philipChoice: 2,
            tommyChoice: 1,
            myChoice: null
        },
        {
            id: 8,
            prompt: 'I am a person of color (POC)',
            notMeValue: 1,
            meValue: -1,
            naValue: 0,
            artChoice: 2,
            nicoChoice: 2,
            philipChoice: 2,
            tommyChoice: 1,
            myChoice: null
        },
        {
            id: 9,
            prompt: 'I grew up in a family where it was okay to be gay or bisexual',
            notMeValue: -1,
            meValue: 2,
            naValue: 0,
            artChoice: 1,
            nicoChoice: 2,
            philipChoice: 1,
            tommyChoice: 2,
            myChoice: null
        },
        {
            id: 10,
            prompt: 'I grew up in a middle or upper class household',
            notMeValue: -1,
            meValue: 1,
            naValue: 0,
            artChoice: 1,
            nicoChoice: 2,
            philipChoice: 2,
            tommyChoice: 2,
            myChoice: null
        },
        {
            id: 11,
            prompt: 'I’ve been called a homophobic name like “fag”, “joto”, “homo”, etc.',
            notMeValue: 1,
            meValue: -1,
            naValue: 0,
            artChoice: 1,
            nicoChoice: 2,
            philipChoice: 2,
            tommyChoice: 2,
            myChoice: null
        },
        {
            id: 12,
            prompt: 'I was raised in a community/neighborhood where I ALWAYS felt safe from harm and violence',
            notMeValue: -1,
            meValue: 1,
            naValue: 0,
            artChoice: 1,
            nicoChoice: 2,
            philipChoice: 2,
            tommyChoice: 2,
            myChoice: null
        },
        {
            id: 13,
            prompt: 'I have a mother/father/brother/sister who is or has been addicted to drugs or alcohol',
            notMeValue: 1,
            meValue: -1,
            naValue: 0,
            artChoice: 1,
            nicoChoice: 1,
            philipChoice: 1,
            tommyChoice: 2,
            myChoice: null
        },
        {
            id: 14,
            prompt: 'I (or my family) have received public aid in the past.',
            notMeValue: 1,
            meValue: -1,
            naValue: 0,
            artChoice: 2,
            nicoChoice: 1,
            philipChoice: 2,
            tommyChoice: 1,
            myChoice: null
        },
        {
            id: 15,
            prompt: 'I’ve been stopped or harassed by police because of my race or ethnicity',
            notMeValue: 2,
            meValue: -2,
            naValue: 0,
            artChoice: 2,
            nicoChoice: 2,
            philipChoice: 2,
            tommyChoice: 1,
            myChoice: null
        },
        {
            id: 16,
            prompt: 'I’ve been called a name based on my race/ethnicity',
            notMeValue: 1,
            meValue: -2,
            naValue: 0,
            artChoice: 2,
            nicoChoice: 2,
            philipChoice: 1,
            tommyChoice: 1,
            myChoice: null
        },
        {
            id: 17,
            prompt: 'My citizenship has been questioned by acquaintances, strangers, and/or people of authority.',
            notMeValue: 1,
            meValue: -1,
            naValue: 0,
            artChoice: 2,
            nicoChoice: 2,
            philipChoice: 1,
            tommyChoice: 1,
            myChoice: null
        },
        {
            id: 18,
            prompt: 'People have told me that I should “act more straight.”',
            notMeValue: 1,
            meValue: -1,
            naValue: 0,
            artChoice: 1,
            nicoChoice: 2,
            philipChoice: 1,
            tommyChoice: 2,
            myChoice: null
        }
    ],
    'id'
);

export { stepUpStepBackChoices, stepUpStepBackPrompts };
